const API_BASE = import.meta.env.VITE_API_BASE || "https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev";

function buildUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });
  return url;
}

export async function fetchChecklistOpsProjects() {
  const response = await fetch(buildUrl("/ops-checklist-summary"));
  if (!response.ok) {
    throw new Error(`Ops checklist projects API error: ${response.status}`);
  }
  return await response.json();
}

export async function fetchChecklistOpsSummary({ project_id }) {
  const response = await fetch(buildUrl("/ops-checklist-summary", { project_id }));
  if (!response.ok) {
    throw new Error(`Ops checklist summary API error: ${response.status}`);
  }
  return await response.json();
}
